import styles from './TagChip.module.scss'

type Props = {
  tag: string
}

export const TagChip: React.FC<Props> = ({ tag }) => {
  return (
    <div className={styles.main_container}>
      <p className={styles.tag_chip_text}>{tag}</p>
    </div>
  )
}
